import { API, graphqlOperation } from "aws-amplify";
import {
  Mail,
  ListMailByNotificationEventIdSortBySortIndexQuery,
} from "types/graphqlapi";
import { listMailByNotificationEventIdSortBySortIndex } from "graphql/queries";

export const listMailByNotificationEventIdQuery = async (
  notificationEventId: string
) => {
  let list: Mail[] = [];
  let nextToken = null;

  do {
    const result = (await API.graphql(
      graphqlOperation(listMailByNotificationEventIdSortBySortIndex, {
        notification_event_id: notificationEventId,
        limit: 100,
        nextToken,
      })
    )) as {
      data: ListMailByNotificationEventIdSortBySortIndexQuery;
    };
    const data = result.data.listMailByNotificationEventIdSortBySortIndex;
    const items = (data?.items || []) as Mail[];

    nextToken = data?.nextToken;

    list = [...list, ...items];
  } while (nextToken);

  return list;
};
